<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <v-row justify="center" class="my-5">
            <v-col cols="12" sm="6">
                <p class="text-center font-weight-bold">
                    {{ sender.destination_user_name }} ( {{ sender.destination_email_address }} ) 様より
                </p>
                <p class="text-center font-weight-bold">
                    契約の確認依頼が届きました。
                </p>
                <p class="text-center">
                    <a href="/support" target="_blank" rel="noopener noreferrer">DX-Signの使い方</a>
                </p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="10">
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row justify="center" class="mt-10">
            <v-col cols="12" sm="5">
                <p class="text-center" v-if="!isLogin">
                    <a href="/documents/terms" target="_blank" rel="noopener noreferrer">利用規約</a>に同意の上、契約の内容を確認してください。
                </p>
                <p class="text-center">
                    <v-icon color="orange">mdi-alert-outline</v-icon>
                    この契約は秘密のアクセスコードの入力が求められています。
                </p>
            </v-col>
        </v-row>
        <validation-observer ref="observer" v-slot="{ invalid }" >
          <form @submit.prevent="submit">
            <v-row justify="center">
                <v-col class="py-0" cols="12" sm="4">
                    <badge-component tile color="red" content="必 須">
                        <label-component>アクセスコード</label-component>
                    </badge-component>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="4">
                    <validation-provider v-slot="{ errors }" name="code" rules="required|max:255" >
                        <!-- autocomplate対策ダミー -->
                        <input type="password" name="hidden" id="hidden2" style="width: 0; height: 0; border: 0; padding: 0; top:-100px; position: fixed;" tabindex="-1" />
                        <v-text-field v-model="code" :error-messages="errors" :type="'password'" required outlined clearable v-disabled-icon-focus autocomplete="new-password" background-color="white"></v-text-field>
                    </validation-provider>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-btn
                  class="white--text"
                  color="red"
                  v-on:click="submit"
                  :disabled="invalid"
                >
                  <span v-if="!isLogin">利用規約に同意して</span>契約を確認する
                </v-btn>
            </v-row>
          </form>
        </validation-observer>
    </div>
</template>

<script>
    import axios from 'axios';
    import { required } from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    
    extend('required', {
        ...required,
        message: '入力必須項目です',
    });
    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            sender: {
                type: Object,
            },
            recipient: {
                type: Object,
            },
            isLogin: Boolean,
        }, 
        data: function () {
            return {
                code: null,
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        methods: {
          clear: function () {
            this.code = '';
            // バリデーションをリセット
            this.$refs.observer.reset();
          },
          submit: async function () {
            var self = this;
            this.sending = true;
            try {
                // バリデーション実行
                await this.$refs.observer.validate().then((result) => {
                  if(result) {
                    var params = {
                      'code': self.code,
                    };
                    axios.post('auth', params)
                    .then(function (response) {
                        if (response.data.success) {
                            window.location = "sign-input";
                        } 
                        else {
                            result = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "認証処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        result = false;
                        console.log(response);
                        self.message.text = "認証処理に失敗しました";
                        self.message.success = false;
                    });
                  }
                });
            }
            finally {
                this.sending = false;
            }
          }
        },
  };
</script>